import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Label from "../../components/Common/Label";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import SearchBar from "../../components/Common/Searchbar";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import CustomIconButton from "../../components/Form/CustomIconButton";
import CustomSelect2 from "../../components/Form/CustomSelect2";
import DatePickerFilter from "../../components/Form/DatePickerFilter";
import RenderPopOverButton from "../../components/Form/RenderPopOverButton.js";
import Helpers from "../../helpers/helpers";
import { deleteOrder, exportOrder, getOrderDetails, getOrderListing, markAsPaidOrder, resetOrderAttachmentState, resetOrderState, resetProductState, revertOrderStatus, updateOrderStatus } from "../../store/actions";
import CancelOrder from "./OrderModal/CancellOrder.js";
import CloseOrder from "./OrderModal/CloseOrder.js";
import CollectPayment from "./OrderModal/CollectPayment.js";
import DeleteOrder from "./OrderModal/DeleteOrder.js";
import DeliverOrder from "./OrderModal/DeliverOrder.js";
import InsufficientPointsCancel from "./OrderModal/InsufficientPointsCancel.js";
import RefundOrder from "./OrderModal/RefundOrder.js";
import ReopenOrder from "./OrderModal/ReopenOrder.js";
import RevertOrder from "./OrderModal/RevertOrder.js";
import ShippedOrder from "./OrderModal/ShippedOrder.js";
import AppDialog from "../../components/Common/AppDialog.js";


const OrderManagement = ({ userPermission, orderListing, orderDetails, orderDelete, orderUpdateStatus, orderRevertStatus, orderExport, paymentTypeList, markAsPaid, courier_list, shippingMethodList }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(resetOrderState());
        dispatch(resetProductState());
    }, [])

    const [loading, setIsLoading] = useState(false);
    const [selectedRow, setSelectedRow] = useState();
    const [orderListingData, setOrderListingData] = useState();
    const [checkedAll, setCheckedAll] = useState(false);
    const [filterObject, setFilterObject] = useState({ platform: '0', date: null, status: '0' });
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [keyword, setSearch] = useState("");
    const [sort, setSorted] = useState("asc");
    const [sort_by, setSortBy] = useState();
    const [collectPaymentOpen, setCollectPaymentOpen] = useState(false);
    const [cancelOrderOpen, setCancelOrderOpen] = useState(false);
    const [deleteOrderOpen, setDeleteOrderOpen] = useState(false);
    const [markDeliveredOpen, setMarkDelieveredOpen] = useState(false);
    const [markClosedOpen, setMarkClosedOpen] = useState(false);
    const [markShippedOpen, setMarkShippedOpen] = useState(false);
    const [revertStatusOpen, setRevertStatusOpen] = useState(false);
    const [reopenOrderOpen, setReopenOrderOpen] = useState(false);
    const [readyPickupOpen, setReadyPickupOpen] = useState(false);
    const [refundOpen, setRefundOpen] = useState(false);
    const [insufficientPointsOpen, setInsufficientPointsOpen] = useState(false);
    const [pendingCancelReason, setPendingCancelReason] = useState('');
    const [insufficientPointsInfo, setInsufficientPointsInfo] = useState({
        pointsRequired: 0,
        pointsAvailable: 0,
    });
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [creatable, setCreatable] = useState(false);
    const [viewable, setViewable] = useState(false);
    const [editable, setEditable] = useState(false);
    const [deletable, setDeletable] = useState(false);
    const [exportable, setExportable] = useState(false);
    const searchRef = useRef(keyword);

    useEffect(() => {
        if (userPermission?.length > 0) {
            !userPermission?.includes("view-order") && navigate('/not-authorized');
            userPermission?.includes("create-order") && setCreatable(true);
            userPermission?.includes("export-order") && setExportable(true);
            userPermission?.includes("view-order") && setViewable(true);
            userPermission?.includes("edit-order") && setEditable(true);
            userPermission?.includes("delete-order") && setDeletable(true);
        }
    }, [userPermission])

    useEffect(() => {
        initData();
    }, [page, length, sort, sort_by, filterObject])

    useEffect(() => {
        searchRef.current = keyword;
    }, [keyword]);

    useEffect(() => {
        if (orderListing?.data) {
            setOrderListingData(orderListing?.data);
        }
    }, [orderListing])

    useEffect(() => {
        if (orderDetails?.code === 'success' && selectedRow) {
            setRefundOpen(true);
        }
    }, [orderDetails])

    useEffect(() => {
        if (markAsPaid?.code === 'success') {
            setNotification({
                open: true,
                msg: 'Order mark as paid successfully',
                type: 'success'
            })
            setCollectPaymentOpen(false);
            initData();
            setIsLoading(false);
        }
    }, [markAsPaid])

    useEffect(() => {
        if (orderUpdateStatus?.success === true) {
            setIsLoading(false);
            setCancelOrderOpen(false);
            setMarkShippedOpen(false);
            setReadyPickupOpen(false);
            setMarkDelieveredOpen(false);
            setMarkClosedOpen(false);
            setRefundOpen(false);
            setInsufficientPointsOpen(false);
            setPendingCancelReason('');
            setNotification({
                open: true,
                msg: 'Order status updated successfully',
                type: 'success'
            })
            dispatch(resetOrderState());
            initData();
        } else if (orderUpdateStatus?.success === false) {
            setIsLoading(false);
            if (orderUpdateStatus?.code === 'insufficient_points') {
                setCancelOrderOpen(false);
                setInsufficientPointsInfo({
                    pointsRequired: orderUpdateStatus?.points_required ?? 0,
                    pointsAvailable: orderUpdateStatus?.points_available ?? 0,
                });
                setInsufficientPointsOpen(true);
                dispatch(resetOrderState());
                return;
            }
            setMarkClosedOpen(false);
            setMarkShippedOpen(false);
            setMarkDelieveredOpen(false);
            setReadyPickupOpen(false);
            setCancelOrderOpen(false);
            setRefundOpen(false);
            setNotification({
                open: true,
                msg: orderUpdateStatus?.message || 'Failed to update order status',
                type: 'error'
            })
            dispatch(resetOrderState());
            initData();
        }
    }, [orderUpdateStatus])

    useEffect(() => {
        if (orderRevertStatus?.success === true) {
            setRevertStatusOpen(false);
            setReopenOrderOpen(false);
            setIsLoading(false);
            setNotification({
                open: true,
                msg: reopenOrderOpen || orderRevertStatus?.status
                    ? 'Order reopened successfully'
                    : 'Order status reverted',
                type: 'success'
            })
            dispatch(resetOrderState());
            initData();
        } else if (orderRevertStatus?.success === false) {
            setReopenOrderOpen(false);
            setIsLoading(false);
            setNotification({
                open: true,
                msg: orderRevertStatus?.message || 'Order status revert failed',
                type: 'error'
            })
            dispatch(resetOrderState());
        }
    }, [orderRevertStatus])

    useEffect(() => {
        if (orderDelete?.code === 'success') {
            setNotification({
                open: true,
                msg: 'Order deleted successfully',
                type: 'success'
            })
            setDeleteOrderOpen(false);
            dispatch(resetOrderState());
            initData();
        }
    }, [orderDelete])

    useEffect(() => {
        if (orderExport?.code === 'success' && orderExport?.excel_base64) {
            Helpers.handleDownloadExcelFile(orderExport.excel_base64, 'order_listing');
            dispatch(resetOrderAttachmentState());
        }
        setIsLoading(false);
    }, [orderExport])

    const platformList = [
        { value: "0", label: "All platforms" },
        { value: "aspeed", label: "Aventrix" },
        { value: "ariba", label: "Ariba" },
    ]


    const pendingOrderDropdown = [
        { iconName: 'ri-check-line', label: 'Mark as paid', color: '#282828', permission: editable, onClick: () => setCollectPaymentOpen(true) },
        { iconName: 'ri-close-line', label: 'Cancel order', color: '#282828', permission: editable, onClick: () => setCancelOrderOpen(true) },
        { iconName: 'ri-delete-bin-line', label: 'Delete', color: '#44d62c', permission: deletable, onClick: () => setDeleteOrderOpen(true) },
    ];

    const confirmOrderDropdown = [
        { iconName: 'mdi:truck-check-outline', isNotRemixIcon: true, label: 'Mark as shipped', color: '#282828', permission: editable, onClick: () => setMarkShippedOpen(true) },
        { iconName: 'ri-arrow-go-back-line', label: 'Refund', color: '#282828', permission: editable, onClick: () => handleRefundModalOpen() },
        { iconName: 'ri-close-line', label: 'Cancel order', color: '#282828', permission: editable, onClick: () => setCancelOrderOpen(true) },
    ];

    const shippedOrderDropdown = [
        { iconName: 'mdi:truck-check-outline', isNotRemixIcon: true, label: 'Mark as delivered', color: '#282828', permission: editable, onClick: () => setMarkDelieveredOpen(true) },
        { iconName: 'ri-arrow-go-back-line', label: 'Refund', color: '#282828', permission: editable, onClick: () => handleRefundModalOpen() },
        { iconName: 'ri-close-line', label: 'Cancel order', color: '#282828', permission: editable, onClick: () => setCancelOrderOpen(true) },
        { iconName: 'mdi:circle-arrows', isNotRemixIcon: true, label: 'Revert to confirmed', color: '#282828', permission: editable, onClick: () => setRevertStatusOpen(true) },
    ];

    const readyPickupOrderDropdown = [
        { iconName: 'mdi:truck-check-outline', isNotRemixIcon: true, label: 'Mark as Ready For Pickup', color: '#282828', permission: editable, onClick: () => setReadyPickupOpen(true) },
        { iconName: 'ri-arrow-go-back-line', label: 'Refund', color: '#282828', permission: editable, onClick: () => handleRefundModalOpen() },
        { iconName: 'ri-close-line', label: 'Cancel order', color: '#282828', permission: editable, onClick: () => setCancelOrderOpen(true) },
        { iconName: 'mdi:circle-arrows', isNotRemixIcon: true, label: 'Revert to confirmed', color: '#282828', permission: editable, onClick: () => setRevertStatusOpen(true) },
    ];

    const pickupOrderDropdown = [
        { iconName: 'mdi:invoice-check-outline', isNotRemixIcon: true, label: 'Close order', color: '#282828', permission: editable, onClick: () => setMarkClosedOpen(true) },
        { iconName: 'ri-arrow-go-back-line', label: 'Refund', color: '#282828', permission: editable, onClick: () => handleRefundModalOpen() },
        { iconName: 'ri-close-line', label: 'Cancel order', color: '#282828', permission: editable, onClick: () => setCancelOrderOpen(true) },
        { iconName: 'mdi:circle-arrows', isNotRemixIcon: true, label: 'Revert to confirmed', color: '#282828', permission: editable, onClick: () => setRevertStatusOpen(true) },
    ];

    const deliveredDropdown = [
        { iconName: 'mdi:invoice-check-outline', isNotRemixIcon: true, label: 'Close order', color: '#282828', permission: editable, onClick: () => setMarkClosedOpen(true) },
        { iconName: 'ri-arrow-go-back-line', label: 'Refund', color: '#282828', permission: editable, onClick: () => handleRefundModalOpen() },
        { iconName: 'ri-close-line', label: 'Cancel order', color: '#282828', permission: editable, onClick: () => setCancelOrderOpen(true) },
        { iconName: 'mdi:circle-arrows', isNotRemixIcon: true, label: 'Revert to shipped', color: '#282828', permission: editable, onClick: () => setRevertStatusOpen(true) },
    ];

    const closedOrderDropdown = [
        { iconName: 'mdi:circle-arrows', isNotRemixIcon: true, label: 'Reopen order', color: '#282828', permission: editable, onClick: () => setReopenOrderOpen(true) },
    ];

    const refundedDropdown = [
        { iconName: 'mdi:invoice-check-outline', isNotRemixIcon: true, label: 'Close Order', color: '#282828', permission: editable, onClick: () => setMarkClosedOpen(true) },
    ];

    const partiallyRefundedDropdown = [
        { iconName: 'mdi:invoice-check-outline', isNotRemixIcon: true, label: 'Close Order', color: '#282828', permission: editable, onClick: () => setMarkClosedOpen(true) },
        { iconName: 'ri-arrow-go-back-line', label: 'Refund', color: '#282828', permission: editable, onClick: () => handleRefundModalOpen() },
    ];

    const header = [
        {
            Header: "Order ID",
            columnID: "id",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <div>#{cellProps?.invoice_display_id || cellProps?.id || '-'}</div>
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Order Created",
            columnID: "created_date",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.created_date || '-'}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Customer",
            columnID: "customer_name",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.customer_name || '-'}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Sales Platform",
            columnID: "order_platform",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.order_platform}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Total",
            columnID: "order_amount",
            accessor: (cellProps) => {
                return (<React.Fragment>S${cellProps?.formatted_order_amount || '0.00'}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Payment Status",
            columnID: "payment_status",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.payment_status && cellProps?.payment_status !== '-' ? <Label.PaymentStatusLabel label={cellProps?.payment_status || 'Paid'} /> : '-'}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Items",
            columnID: "items_count",
            accessor: (cellProps) => {
                return (<React.Fragment>{cellProps?.total_items_count || '0 item'}</React.Fragment>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Order Status",
            columnID: "order_status",
            accessor: (cellProps) => {
                return (<React.Fragment><Label.OrderLabel label={cellProps?.order_status} /></React.Fragment>)
            },
            minWidth: 200,
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            accessor: (cellProps) => {
                let dropdownList = cellProps?.order_status === 'pending' ? pendingOrderDropdown :
                    cellProps?.order_status === 'ordered' ? cellProps?.shipping_method_id === 2 ? readyPickupOrderDropdown : confirmOrderDropdown :
                        cellProps?.order_status === 'shipped' ? shippedOrderDropdown :
                            cellProps?.order_status === 'ready_for_pickup' ? pickupOrderDropdown :
                                cellProps?.order_status === 'delivered' ? deliveredDropdown :
                                    cellProps?.order_status === 'closed' ? closedOrderDropdown :
                                        cellProps?.order_status === 'refunded' ? refundedDropdown :
                                            cellProps?.order_status === 'partially_refunded' ? partiallyRefundedDropdown :
                                                null
                return (
                    <div className="d-flex">
                        {viewable && <Link to={`/view-order/${(cellProps?.order_platform || 'aspeed').toLowerCase()}/${cellProps.id}`}>
                            <CustomIconButton
                                iconName={'ri-eye-line'}
                                onClick={() => { '' }}
                            />
                        </Link>}
                        {
                            cellProps?.order_platform !== 'Ariba' && cellProps?.order_status !== 'cancelled' && cellProps?.order_status !== 'payment_failed' &&
                            (editable || (cellProps?.order_status === 'pending' && deletable)) &&
                            <div onClick={() => { setSelectedRow(cellProps) }} style={{ cursor: 'pointer' }}>
                                <RenderPopOverButton
                                    items={dropdownList}
                                />
                            </div>
                        }
                    </div>
                )
            },
            minWidth: 120,
            position: 'sticky',
            disableFilters: true,
            filterable: false,
        }
    ]

    const initData = () => {
        let payload = {
            paginate: page,
            sort: sort_by,
            sort_order: sort,
            size: length,
            search: searchRef.current,
            filterStatus: filterObject?.status === 'all' ? '' : filterObject.status,
            filterDate: filterObject?.date || '',
            filterPlatform: filterObject?.platform || ''
        }
        dispatch(getOrderListing(payload));
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage("1");
                initData();
            }
        }, Helpers.searchInterval);
    }

    const resetFilter = () => {
        setPage("1");
        setFilterObject({ platform: '0', date: null, status: '0' });
        searchRef.current = '';
        setSearch('');
    }

    const handleExport = () => {
        let filter = {
            status: filterObject?.status,
            platform: filterObject?.platform,
            created_at: filterObject?.date,
        }
        Object.keys(filter).forEach(key => {
            if (!filter[key] || filter[key] === 'all' || filter[key] === "0") {
                delete filter[key];
            }
        });
        setIsLoading(true);
        dispatch(exportOrder({ filter: filter, sort: sort_by, sort_order: sort, search: keyword }));
    }
    const handleMarkOrderAsPaid = (paymentData) => {
        if (paymentData?.payment_type && paymentData?.amount) {
            setIsLoading(true);
            let payload = {
                order_id: selectedRow?.id,
                payment_method_id: paymentData?.payment_type,
                payment_method: paymentTypeList.filter((item) => item.id === paymentData?.payment_type)[0]?.type,
                order_amount: paymentData?.amount
            }
            dispatch(markAsPaidOrder(payload));
        } else {
            setNotification({
                open: true,
                msg: 'Please fill all fields',
                type: 'warning'
            })
        }
    }

    const handleCancelOrder = (payload, forceWithoutPoints = false) => {
        if (payload) {
            setPendingCancelReason(payload);
            setIsLoading(true);
            let data = {
                id: selectedRow?.id,
                data: {
                    status: 'cancelled',
                    reason: payload || '-',
                    force_cancel_without_points: forceWithoutPoints ? 1 : 0,
                }
            }
            dispatch(updateOrderStatus(data));
        } else {
            setNotification({
                open: true,
                msg: 'Please fill cancellation reason',
                type: 'warning'
            })
        }

    }

    const handleForceCancelWithoutPoints = () => {
        setInsufficientPointsOpen(false);
        handleCancelOrder(pendingCancelReason || '-', true);
    }

    const handleReopenOrder = () => {
        setIsLoading(true);
        dispatch(revertOrderStatus({
            id: selectedRow?.id,
            data: { status: 'reopen' },
        }));
    }

    const handleRevertOrder = (status) => {
        setIsLoading(true);
        let data = {
            id: selectedRow?.id,
            data: {
                status: status,
            }
        }
        dispatch(revertOrderStatus(data));
    }

    const handleDeleteOrder = () => {
        dispatch(deleteOrder({ id: selectedRow?.id }));
        setIsLoading(true);
    }

    const handleMarkAsShipped = (shippedData) => {
        if (shippedData?.courier_service && shippedData?.tracking_no && shippedData?.tracking_url) {
            setMarkShippedOpen(false);
            setIsLoading(true);
            let data = {
                id: selectedRow?.id,
                data: {
                    status: 'shipped',
                    shipping_method_id: shippedData?.shipping_method_id,
                    courier_service: shippedData?.courier_service,
                    tracking_number: shippedData?.tracking_no,
                    tracking_url: shippedData?.tracking_url
                }
            }
            dispatch(updateOrderStatus(data));
        } else {
            setNotification({
                open: true,
                msg: 'Please fill all fields',
                type: 'warning'
            })
        }
    }

    const handleRefund = (refundData) => {
        let verifyPayload = true;
        let addOnList = refundData?.addon_items;

        if (refundData?.refund_amount) {
            let payload = {
                id: selectedRow?.id,
                data: {
                    status: 'refunded',
                    refund_type: refundData?.refund_type,
                    refund_amount: refundData?.refund_amount,
                    order_items: []
                }
            }
            if (refundData?.addon_items?.length > 0) { // push the addon item that without refund main product
                let tempAddonList = [];
                refundData?.addon_items.forEach((addon) => {
                    if (!tempAddonList?.includes(addon?.order_item_id)) { // to prevent add redundant addon item
                        // check if add on item has a main product in refund product array
                        const filteredRefundProduct = refundData?.product_refund?.filter(product => addon?.order_item_id === product?.id)?.length === 0 ? refundData?.addon_items?.filter((filter) => filter?.order_item_id === addon?.order_item_id) : null;
                        if (filteredRefundProduct?.length > 0) {
                            let addonItemList = [];

                            addOnList = addOnList.filter((item) => item?.order_item_id !== addon?.order_item_id);
                            tempAddonList.push(addon?.order_item_id);

                            filteredRefundProduct.map(addon => (
                                addonItemList?.filter((el) => el.id === addon?.id)?.length === 0 && addonItemList.push({
                                    id: addon.id,
                                    quantity: refundData?.addon_items.filter(el => el.id === addon?.id)?.length
                                })))

                            payload.data.order_items.push({
                                id: addon.order_item_id,
                                quantity: 0,
                                addon_items: addonItemList
                            });
                        }
                    }
                });
            }
            refundData?.product_refund?.length > 0 && refundData?.product_refund.map((item) => {
                if (payload.data.order_items?.filter(el => el.id === item.id)?.length === 0) {
                    payload.data.order_items.push({
                        id: item.id,
                        quantity: refundData?.product_refund.filter(el => el.id === item?.id)?.length,
                        addon_items: []
                    })
                    addOnList?.length > 0 && addOnList.filter((filter) => filter?.order_item_id === item?.id)?.map((addon) => {
                        if (payload.data.order_items[payload.data.order_items.length - 1].addon_items?.filter(el => el.id === addon.id)?.length === 0) {
                            payload.data.order_items[payload.data.order_items.length - 1].addon_items.push({
                                id: addon.id,
                                quantity: refundData?.addon_items.filter(el => el.id === addon?.id)?.length
                            });
                        }
                    })
                }
            })

            if (refundData?.product_refund?.length === 0 && refundData?.addon_items?.length === 0) {
                verifyPayload = false;
                setNotification({
                    open: true,
                    msg: 'Please select items to refund',
                    type: 'warning'
                })
            }

            if (verifyPayload) {
                setIsLoading(true);
                dispatch(updateOrderStatus(payload));
            }
        } else {
            setNotification({
                open: true,
                msg: 'Please fill refund amount',
                type: 'warning'
            })
        }

    }

    const handleMarkAsDelivered = () => {
        setIsLoading(true);
        let data = {
            id: selectedRow?.id,
            data: {
                status: 'delivered',
            }
        }
        dispatch(updateOrderStatus(data));
    }

    const handleMarkOrderAsReadyForPickup = () => {
        setIsLoading(true);
        let data = {
            id: selectedRow?.id,
            data: {
                status: 'ready_for_pickup',
                // shipping_method_id: payload.shipping_method_id,
            }
        }
        dispatch(updateOrderStatus(data));
    }

    const handleMarkAsClose = () => {
        setIsLoading(true);
        let data = {
            id: selectedRow?.id,
            data: {
                status: 'closed',
            }
        }
        dispatch(updateOrderStatus(data));
    }

    const handleRefundModalOpen = () => {
        dispatch(getOrderDetails({ id: selectedRow?.id }));
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1}>
                <Grid container item lg={10} md={12} style={{ display: 'flex', alignItems: "center" }} spacing={1}>
                    <Grid item lg={2} md={2} xs={12}>
                        <SearchBar
                            value={keyword}
                            setValue={(e) => { handleSearch(e) }}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12}>
                        <CustomSelect2
                            values={filterObject?.platform || "-1"}
                            onChange={(e) => {
                                setPage("1");
                                setFilterObject((prevValues) => ({
                                    ...prevValues,
                                    platform: e
                                }))
                            }}
                            data={platformList}
                            placeholder={"Platform"}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12}>
                        <DatePickerFilter
                            values={filterObject?.date && new Date(filterObject?.date)}
                            setFormValues={(e) => {
                                setPage("1");
                                setFilterObject((prevValues) => ({
                                    ...prevValues,
                                    date: e
                                }))
                            }}
                            keyword={'date'}
                        />
                    </Grid>
                    <Grid item lg={2} md={2} xs={12}>
                        <CustomSelect2
                            values={filterObject?.status || "-1"}
                            onChange={(e) => {
                                setPage("1");
                                setFilterObject((prevValues) => ({
                                    ...prevValues,
                                    status: e
                                }))
                            }}
                            data={Helpers.statusList}
                            placeholder={"Status"}
                        />
                    </Grid>
                    <Grid item lg={2} md={2} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>
                {exportable && <Grid item lg={2} md={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' } }} alignItems={'center'}>
                    <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />
                </Grid>}
            </Grid>
        )
    }

    const renderHeader = () => {
        return (
            <Grid container className="d-flex justify-content-between align-items-center p-1 pb-2">
                <Grid item lg={9} md={9} xs={12} className="header d-flex">Orders <div className="header-amount mx-2">{orderListing?.data?.total || 0}</div></Grid>
                {
                    creatable &&
                    <Grid item lg={3} md={3} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end', xs: 'start' }, marginTop: { lg: 0, xs: 1 }, }}>
                        <CustomButton
                            title={<><i className="ri-add-line" style={{ marginRight: '5px' }} /> Add Order </>}
                            borderStyle={'1px solid #101010'}
                            backgroundColor={'#101010'}
                            textColor={'white'}
                            press={() => navigate('/add-order')}
                        />
                    </Grid>
                }
            </Grid>
        )
    }
    return (
        <React.Fragment>
            <div className="page-content">
                <LoadingDialog open={loading || !orderListing?.data?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    {renderHeader()}
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={orderListingData?.data || []}
                        pageSize={length}
                        totalPage={orderListingData?.last_page || 1}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        setCheckedAll={setCheckedAll}
                        checkedAll={checkedAll}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={orderListingData?.last_page || 1}
                    />
                </Container>
            </div>
            <AppDialog
                title={'Mark as ready for pickup'}
                titleIcon={'complete'}
                open={readyPickupOpen}
                close={() => setReadyPickupOpen(false)}
                positiveTitle={'Confirm'}
                positivePress={() => handleMarkOrderAsReadyForPickup()}
                negativePress={() => setReadyPickupOpen(false)}
                negativeTitle={'Cancel'}
                width={'40%'}
            >
                <div >Are you sure to confirm to set the order status to "Ready for pickup".</div>
            </AppDialog>
            <CollectPayment
                open={collectPaymentOpen}
                close={() => setCollectPaymentOpen(false)}
                paymentList={paymentTypeList || []}
                submit={(payload) => handleMarkOrderAsPaid(payload)}
            />
            <CancelOrder
                open={cancelOrderOpen}
                close={() => setCancelOrderOpen(false)}
                earnedPointsGiven={selectedRow?.earned_points_given || orderDetails?.data?.earned_points_given || 0}
                submit={(payload) => handleCancelOrder(payload)}
            />
            <InsufficientPointsCancel
                open={insufficientPointsOpen}
                close={() => {
                    setInsufficientPointsOpen(false);
                    setPendingCancelReason('');
                }}
                pointsRequired={insufficientPointsInfo.pointsRequired}
                pointsAvailable={insufficientPointsInfo.pointsAvailable}
                submit={() => handleForceCancelWithoutPoints()}
            />
            <ReopenOrder
                open={reopenOrderOpen}
                close={() => setReopenOrderOpen(false)}
                submit={() => handleReopenOrder()}
            />
            <RevertOrder
                open={revertStatusOpen}
                close={() => setRevertStatusOpen(false)}
                status={selectedRow?.order_status}
                submit={(payload) => handleRevertOrder(payload)}
            />
            <DeleteOrder
                open={deleteOrderOpen}
                close={() => setDeleteOrderOpen(false)}
                submit={() => handleDeleteOrder()}
            />
            <ShippedOrder
                open={markShippedOpen}
                close={() => setMarkShippedOpen(false)}
                courierList={courier_list}
                orderData={selectedRow}
                shippingMethodList={shippingMethodList}
                submit={(payload) => handleMarkAsShipped(payload)}
            />
            <RefundOrder
                open={refundOpen}
                close={() => setRefundOpen(false)}
                refundData={orderDetails?.data?.items}
                pointsEnabled={orderDetails?.points_enabled !== false && orderListing?.points_enabled !== false}
                submit={(payload) => handleRefund(payload)}
            />
            <DeliverOrder
                open={markDeliveredOpen}
                close={() => setMarkDelieveredOpen(false)}
                submit={() => handleMarkAsDelivered()}
            />
            <CloseOrder
                open={markClosedOpen}
                close={() => setMarkClosedOpen(false)}
                submit={() => handleMarkAsClose()}
            />
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Order, General }) {
    const courier_list = General.courier_list && Object.entries(General.courier_list).map(([key, value]) => ({
        label: value,
        value: key
    }));
    const shippingMethodList = General.shipping_methods?.length > 0 ? General.shipping_methods?.filter((item) => item?.status === 1) : [];
    return {
        userPermission: Login.permissionArry,
        paymentTypeList: General.payment_type,
        courier_list: courier_list,
        shippingMethodList: shippingMethodList,
        orderListing: Order.orderListing,
        orderDetails: Order.orderDetails,
        orderDelete: Order.deleteOrder,
        markAsPaid: Order.markOrderAsPaid,
        orderUpdateStatus: Order.updateOrderStatus,
        orderRevertStatus: Order.revertOrderStatus,
        orderExport: Order.exportOrder,
    };
}

export default connect(mapStateToProps)(OrderManagement);